import React from 'react';
import * as shapes from '../../shapes';
import { t } from '../../../../modules/infra/i18n';

const ProductSaleChargeButton = ({ charge, disabled }) => (
  <button
    type="button"
    className="c-btn"
    onClick={charge}
    disabled={disabled}
  >
    {t('common:modal.confirm_button')}
  </button>
);

ProductSaleChargeButton.propTypes = {
  charge: shapes.handler.isRequired,
  disabled: shapes.flag.isRequired,
};

export default ProductSaleChargeButton;
